import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useClaimEarnRewardsMutation } from '@/api/queries/rewards';
import { defaultToastConfig } from '@/common/config/toast';
import { Playdeck } from '@/common/lib/playdeck';
import { type Reward } from '@/common/types/earnRewardsType';
import ClaimRewardButton from '@/components/DailyReward/ClaimRewardButton/ClaimRewardButton';
import DailyRewardTitle from '@/components/DailyReward/DailyRewardTitle/DailyRewardTitle';
import RewardsList from '@/components/DailyReward/RewardsList/RewardsList';
import { showToast } from '@/components/ui/Notification/SwipeableToastNotification';
import { addToBalance } from '@/redux/reducers/userReducer';
import { useAppDispatch } from '@/redux/store';

interface EarnRewardScreenProps {
  activeReward?: Reward;
  allRewards?: Reward[];
  seconds: number;
  setRewardAnimating: (arg: Reward | null) => void;
}

const EarnRewardScreen: FC<EarnRewardScreenProps> = ({
  activeReward,
  allRewards,
  seconds,
  setRewardAnimating,
}) => {
  const [claimEarnRewards, { isLoading }] = useClaimEarnRewardsMutation();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const onClick = (): void => {
    if (!activeReward) return;
    const index = allRewards?.findIndex(({ id }) => id === activeReward.id);
    claimEarnRewards()
      .unwrap()
      .then(() => {
        setRewardAnimating(activeReward);
        dispatch(addToBalance(activeReward.reward));
        Playdeck.sendAnalitics({
          type: 'custom_event',
          name: 'free_bonus',
          user_properties: {},
          event_properties: {
            amount: 1,
            type: `daily${Number(index) + 1}`,
            reward: activeReward.reward,
          },
        });
      })
      .catch((error: unknown) => {
        console.error(error);
        showToast(t('Referral link copied.'), undefined, {
          ...defaultToastConfig,
          className: 'justify-center',
        });
      });
  };

  return (
    <>
      <div className="flex flex-col items-center self-stretch flex-1 overflow-auto pt-4">
        <DailyRewardTitle />
        <RewardsList
          activeReward={activeReward}
          rewards={allRewards}
          className="pb-10 "
        />
      </div>
      <ClaimRewardButton
        isLoading={isLoading}
        seconds={seconds}
        onClick={onClick}
        activeReward={activeReward}
      />
    </>
  );
};

export default EarnRewardScreen;
